const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_pages/$lang/_legal.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_pages/$lang/_legal")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});